export const fillTopLabels = (chartData) => {
    const datasets = chartData?.datasets ?? []

    const maxDataEntries = datasets.reduce((maxLength, dataset) => {
        const length = dataset?.data?.length ?? 0
        return Math.max(length, maxLength)
    }, 0)

    return new Array(maxDataEntries).fill("")
}
